/* eslint-disable padded-blocks */
import { BasketUrl, CheckoutUrl, ProductsUrl } from 'routes/wallet.routes';
import request from 'services/request';
import { PackageType, PdfOrSecurityPackageDataType } from 'typings/wallet.type';
import {
  generatePackagesData,
  handlePackageQueryParams,
} from 'utils/wallet.util';

export const getProductsDataAction = async (set): Promise<PackageType[]> => {
  set(() => ({
    productsLoading: true,
    productsError: false,
  }));

  const response = await request.get(ProductsUrl());
  const responseData = generatePackagesData(response?.data?.data?.packages);
  response.ok
    ? set(() => ({
        productsData: responseData,
        banner: response?.data?.data?.pwa_banner,
        productsLoading: false,
      }))
    : set({
        productsLoading: false,
        productsError: true,
      });
  return response?.data?.data?.packages;
};

export const getBasketDataAction = async (set, couponCode?): Promise<void> => {
  set(() => ({ basketLoading: true, basketError: false }));

  const response = await request.get(BasketUrl(couponCode));
  const responseData = response?.data?.data;
  set(() => ({ basketLoading: false, basketError: response.ok }));
  response.ok &&
    set(() => ({ basketData: responseData, userCouponCode: couponCode || '' })); // for does time couponCode is wrong
};

export const getCheckoutAction = async (set, couponCode?): Promise<string> => {
  set(() => ({ checkoutLoading: true }));
  const response = await request.get(CheckoutUrl(couponCode), {
    showSuccessMessage: false,
  });
  set(() => ({ checkoutLoading: false }));
  return response.ok ? response.data.data.redirect_urls[0].link : null;
};

export const putBasketDataAction = async (set): Promise<void> => {
  set(() => ({ putBasketLoading: true }));
  const response = await request.put(BasketUrl(), { status: 'open' });
  set(() => ({ putBasketLoading: false }));
  const responseData = response?.data?.data;
  response.ok && set(() => ({ basketData: responseData }));
};

export const postAddPackageToBasketAction = async (
  set,
  selectedPackage: PackageType,
  packageList?: PdfOrSecurityPackageDataType[],
  queryParam?: { simple_package?: string; combined_package?: string },
): Promise<void> => {
  set(() => ({ deletePackageLoading: selectedPackage.id })); // to just show loading for selectedPackage we need id
  const response = await request.post(
    // there are 4 type of packages and we check it here
    // package data can be combined package, simple package, pdf or security
    BasketUrl(),
    handlePackageQueryParams(selectedPackage, packageList, queryParam),
  );
  const responseData = response?.data?.data;
  set(() => ({ deletePackageLoading: null }));
  response.ok && set(() => ({ basketData: responseData }));
};

export const deletePackageAction = async (set, id, isSimple): Promise<void> => {
  set(() => ({ deletePackageLoading: id }));
  const data = isSimple ? { simple_package: id } : { combined_package: id };
  const response = await request.delete(BasketUrl(id), {}, { data });
  response.ok && (await getBasketDataAction(set));
  set(() => ({ deletePackageLoading: null }));
};
